import React, { useContext, useEffect, useState } from 'react';
import { PlannerContext } from '@/context/PlannerContext';

const useEventColour = () => {

    const [cellStyle, setCellStyle] = useState<{borderColor:string, backgroundColor:string}>({borderColor:"", backgroundColor:""})

    const { selectedCal } = useContext(PlannerContext)

    function hexToRgb(hex) {

        const  result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
         
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : {
            r:"",
            g:"",
            b: ""
        };

    }
      
    useEffect(() => {

        if (selectedCal.value && selectedCal.hexCode){

            if(selectedCal.hexCode !== cellStyle.borderColor){

                const {r, g, b} = hexToRgb(selectedCal.hexCode)

                setCellStyle({
                    'borderColor': selectedCal.hexCode,
                    'backgroundColor':`rgb(${r}, ${g}, ${b}, 0.1)`,
                })
            }
            
        }

    }, [selectedCal])
    
    return {cellStyle}
};

export default useEventColour;